import { ProjectPayload } from "hooks/useProjects/useProjects.types";

/**
 * Determines if a project is a trial project
 *
 * Trial detection logic:
 * - A project is a trial if and only if trial_expiry_date exists (is not null)
 *
 * @param project - The project payload from API
 * @returns true if the project is a trial, false otherwise
 */
export const isProjectTrial = (project: ProjectPayload): boolean => {
  const info = project.permissions?.projectInfo;
  if (info && typeof info.isLicensed === "boolean") {
    return !info.isLicensed;
  }
  if (info?.isTrialProject) {
    return true;
  }
  return Boolean(project.trial_expiry_date || project.purchase_type === "trial");
};

/**
 * Determines if a project is a trial project (for transformed project data)
 *
 * @param project - The transformed project state
 * @returns true if the project is a trial, false otherwise
 */
export const isTransformedProjectTrial = (project: { isTrial?: boolean }): boolean => {
  return Boolean(project.isTrial);
};
